module.exports = __webpack_public_path__ + "img/nodata.f92b3ab8.png";